/*
----- Sliders  ----- 
- No this is NOT carousel logic.
- Input sliders
- Can be used to select attributes in a filter list ( i.e the price slider )
- Single + Double handle ( range ) sliders. 
*/

//----- Dependancies -----
// https://api.jqueryui.com/slider/
import slider from 'jquery-ui-slider/jquery-ui';


// Holds active slider instances.
var instances = {}

function getContext(id) {
    return instances[id]['context'];
}

function getRange(id) {
    let range = instances[id]['range'];
    return range;
}

function getValue(id) {
    let value = instances[id]['value'];
    return value;
}

function getValues(id) {
    let values = instances[id]['values'];
    // If no default values have been set then fallback to the min / max values.
    if (!values) {
        values = [instances[id]['min'],instances[id]['max']];
    }
    return values;
}

function getAttributeList(id) {
    return instances[id]['attributeList'];
}

function getMin(id) {
    let min = instances[id]['min'];
    return parseInt(min);
}

function getMax(id) {
    let max = instances[id]['max'];
    // Values override.
    if (instances[id]['values']) {
        max = $(instances[id]['values']).length - 1;
    }
    return parseInt(max);
}

function getStep(id) {
    let step = instances[id]['step'];
    // Fallback.
    if (!step) {
        step = 1;
    }
    return parseInt(step);
}

function getStartValues(id, getIndexValue) {
    // Get start values array.
    let startValues = instances[id]['startValues'];
    // Get values array.
    let values = instances[id]['values'];

    if (getIndexValue && values) {
        // Find the index values for the min & max handles.
        let getMinStartPosition = getClosestIndexValue(values, startValues[0]);

        let getMaxStartPosition = getClosestIndexValue(values, startValues[1]);
        // Assign index's to the startValues array.
        startValues = [getMinStartPosition, getMaxStartPosition];
    }

    if (!startValues) {
        startValues = false;
    }

    return startValues;
}

function getOrientation(id) {
    let orientation = instances[id]['orientation'];
    // Fallback.
    if (!orientation) {
        orientation = "horizontal";
    }
    return String(orientation);
}

function getAnimation(id) {
    let animation = instances[id]['animation'];
    if (!animation) {
        animation = true;
    }
    return animation;
}

function getOptionPrefix(id) {
    let optionPrefix = instances[id]['option-prefix'];
    return optionPrefix;
}

function getIncrementValues(id) {
    let incrementValues = instances[id]['increment-values'];
    return incrementValues;
}

function getDecrementValues(id) {
    let decrementValues = instances[id]['decrement-values'];
    return decrementValues;
}


//var context = "";


function initialiseAll() {
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Attempting to initialise ALL sliders on the page.")
    }
    
    let sliders = $(expressSelectors()['slider']['initialise']);

    if (sliders.length > 0) {
        sliders.each(function() {
            // Slider context.
            let slider = $(this);
            // Initialise.
            initialise(slider);
        });
        return true;
    }
}

function initialise(element) {
    AXISDebug.output(1,"Sliders: Initialising slider:", element);
    // Store slider context
    let context = element;
    // Generate unique id.
    let id = generateId();
    // Assign id.
    context.attr('slider-id', id);
    // Is this a range slider.
    let range = context.attr('slider-range');
    if (range == "true") {
        range = true;
    }
    // Min value.
    let min = parseInt(context.attr('slider-min'));
    // Max value.
    let max = parseInt(context.attr('slider-max'));
    // Slider values.
    let values = context.data('slider-values');
    // Slider value ids.
    let idArray = context.data('slider-ids');
    // Attribute Id's.
    let attributeList = context.data('slider-attribute-list');
    // Default selected values.
    let startValues = context.data('slider-start-values');
    // Animation.
    let animation = context.attr('slider-animation');
    // Orientation.
    let orientation = context.attr('slider-orientation');
    if (!orientation) {
        orientation = "horizontal";
    }
    // Step.
    let step = parseInt(context.attr('slider-step'));
    // Form input mapping.
    let formInputs = context.data('slider-form-inputs');
    // Added slider id to each input using the input id's provided in formInputs.
    $.each(formInputs, function(key, value) {
        $('#' + value).attr('slider-input', id);
    });
    // Option id ( essentially a value prefix for submission )
    let optionPrefix = context.data('option-prefix');
    // Because jQuery does not store the values in a zero based array which makes comparing this array against the ui array difficult otherwise.
    if (values) {
        values.splice(0,0,0);
    }

    if (attributeList) {
        attributeList.splice(0,0,0);
    }

    if (idArray) {
        idArray.splice(0,0,0);
    }

    // Default step.
    if (isNaN(step)) {
        step = 1;
    }

    // Disabled step.
    if (values && step) {
        step = undefined;
    }
    
    // Min values fallback.
    if (isNaN(min)) {
        min = 1;
    }
    // If you're providing a slider with preset values then you should not provide a max as that is worked out by the the values array.
    if (isNaN(max) && !startValues) {
        if (values) {

            let valuesLength = parseInt(values.length);
            valuesLength = (valuesLength - 1);

            max = values[valuesLength];  
        } else {
            AXISDebug.output(3, "No max defined, you can either add the slider-max attribute or add a data-slider-values attribute");
            return false;
        }
    }

    if (max != undefined && startValues != undefined) {
        if (startValues[1] > max) {
            AXISDebug.output(3, "The start max cannot be greater than the max value");
            return false;
        }
    }

    if (min != undefined && startValues != undefined) {
        if (startValues[0] < min) {
            AXISDebug.output(3, "The start min cannot be less than the min value");
            return false;
        }
    }


    // Use form inputs to get starting position.
    if (!startValues && formInputs) {
        let minStartPosition = parseInt($('#' + formInputs[0]).val());
        let maxStartPosition = parseInt($('#' + formInputs[1]).val());
        if (!isNaN(minStartPosition) && !isNaN(maxStartPosition)) {
            startValues = [];
            startValues.push(minStartPosition);
            startValues.push(maxStartPosition);
        }
    }

    // Increment visual value.
    let incrementValues = context.data('increment-values');
    // Decrement visual value.
    let decrementValues = context.data('decrement-values');

    // If this is not a range slider then you only need one value.
    let value = undefined;

    if (range != true) {
        // TODO: need to get the value of the input this slider is assigned too.
        // Get value form input.
        value = parseInt($('#' + formInputs[0]).val());
    }

    // Create a new instance.
    instances[id] = {};
    // Add instance properties.
    instances[id]['range'] = range;
    instances[id]['min'] = min;
    instances[id]['max'] = max;
    instances[id]['value'] = value;
    instances[id]['values'] = values;
    instances[id]['id-array'] = idArray;
    instances[id]['attributeList'] = attributeList;
    instances[id]['startValues'] = startValues;
    instances[id]['animation'] = animation;
    instances[id]['orientation'] = orientation;
    instances[id]['step'] = step;
    instances[id]['formInputs'] = formInputs;
    instances[id]['option-prefix'] = optionPrefix;
    instances[id]['increment-values'] = incrementValues;
    instances[id]['decrement-values'] = decrementValues;
    instances[id]['context'] = context;

    if (AXISDebug.level() >= 2) {
        AXISDebug.output(1, "Initialising a slider with the following config: ", instances[id])
    }
    
    // Actually initialise the slider!
    context.slider({
        range: getRange(id),
        value: (!getRange(id) ? getValue(id) : null),
        values: (getRange(id) == true ? ((getStartValues(id)) ? getStartValues(id, true) : getValues(id)) : getValue(id)),
        min: getMin(id),
        max: getMax(id),
        step: getStep(id),
        orientation: getOrientation(id),
        animation: getAnimation(id),
        create: (event, ui) => {
            let min = 0, max = 0;
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1, "start values: " + instances[id]['startValues'])
            }
            if (startValues) {
                min = instances[id]['startValues'][0];
                max = instances[id]['startValues'][1];
                let inputValues = setInputValues(id, min, max);

                if (!inputValues) {
                    AXISDebug.output(3,"Could not set slider input values");
                    return false;
                }

                let inputs = inputListeners(id);

                if (!inputs) {
                    AXISDebug.output(3,"Failed to initialise input listeners.");
                    return false;
                }

            } else if (instances[id]['range'] == true && instances[id]['values']) {
                let valuesLength = parseInt(instances[id]['values'].length);
                valuesLength = (valuesLength - 1);

                // If values array is defined then get the min and max value from it.
                // Get the first property from teh array.
                min = instances[id]['values'][1];
                // Extract the last property from the array.
                max = instances[id]['values'][valuesLength];

                // Display the values.
                let inputValues = setInputValues(id, min, max);

                if (!inputValues) {
                    AXISDebug.output(3,"Could not set slider input values");
                    return false;
                }

                let inputs = inputListeners(id);

                if (!inputs) {
                    AXISDebug.output(3,"Failed to initialise input listeners.");
                    return false;
                }
                
            } else if (instances[id]['range'] == true) {
                // Else just use the min & max values.
                min = instances[id]['min'];
                max = instances[id]['max']

                // Display the values.
                let inputValues = setInputValues(id, min, max);

                if (!inputValues) {
                    AXISDebug.output(3,"Could not set slider input values");
                    return false;
                }
            } else {
                // Set value.
                getContext(id).slider('value', getValue(id));
                // Input listener to trigger change.
                inputListeners(id);
            }
        },
        slide: (event, ui) => {
            // Looks to see if this handle has a free text input defined and if it does then add active state.
            let freeTextMatch = instances[id]['formInputs'][ui.handleIndex];
            if (freeTextMatch) {
                $('#' + freeTextMatch).addClass('ui-state-active');
            }
            
            // Make sure slider handles are not overlapping.
            let sliderOverlapping = preventOverlappingSliders(id, ui);
            if (sliderOverlapping) {
                return false;
            }

            let min, minAttributeId, max, maxAttributeId , value;
            // Select the min value from the values from the valueArray based on the min / max handles.
            if (instances[id]['range'] == true && instances[id]['values']) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"AXIS Sliders: This is a range slider with an values array.");
                }
                
                min = instances[id]['values'][ui.values[0]];
                max = instances[id]['values'][ui.values[1]]; 

                let inputValues = setInputValues(id, min, max);

                // Programmatically firing the change event for the price slider so any listeners get fired.
                 $('#' + freeTextMatch).trigger('change');
                
            } else if (instances[id]['range'] == true) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"AXIS Sliders: This is a range slider without an values array.");
                }
                // If there is no valueArray just use the min & max values.
                min = ui.values[0];
                max = ui.values[1]
                
                let inputValues = setInputValues(id, min, max);
                // Programmatically firing the change event for the price slider so any listeners get fired.
                $('#' + freeTextMatch).trigger('change');

            } else {
                if (AXISDebug.level() >= 4) {
                    AXISDebug.output(1,"AXIS Sliders: This is not a range slider.");
                }
                // Get handle value.
                value = ui.value;
                // Assign value.
                $('#' + instances[id]['formInputs'][0]).val(value);
                // Programmatically firing the change event for the price slider so any listeners get fired.
                $('#' + instances[id]['formInputs'][0]).trigger('change');
            }
        },
        start: (event, ui) => {
            // Match handle to input.
            let input = instances[id]['formInputs'][ui.handleIndex];
            // Add active class to input.
            if (input) {
                $('#' + input).addClass('ui-state-active');
            }
        },
        stop: (event, ui) => {
            // Match handle to input.
            let input = instances[id]['formInputs'][ui.handleIndex];
            if (input) {
                $('#' + input).removeClass('ui-state-active');
            }
        }
    });

    return true;
}

function setInputValues(id, min, max) {
    // For filter system submission.
    let optionPrefix = getOptionPrefix(id);
    let incrementValues = getIncrementValues(id);
    let decrementValues = getDecrementValues(id);

    if (max) {
        let value = max;
        if (incrementValues) {
            value = value + 1;
        }
        if (decrementValues) {
            value = value - 1;
        }

        // Assign the max value.
        $('#' + instances[id]['formInputs'][1]).val(value);
        if (optionPrefix) {
            $('#' + instances[id]['formInputs'][1]).attr('data-attribute-id', optionPrefix + max);
        }
    }

    if (min != undefined) {
        let value = min;
        if (incrementValues) {
            value = value + 1;
        }
        if (decrementValues) {
            value = value - 1;
        }
        // Assign the min value.
        $('#' + instances[id]['formInputs'][0]).val(value);
        if (optionPrefix) {
            $('#' + instances[id]['formInputs'][0]).attr('data-attribute-id', optionPrefix + min);
        }
    }
    return true;
}

// Initialise the input listeners and if they're changed then either get their value or match their value with the values array.
function inputListeners(id) {
    let isRange = getRange(id);
    $('#' + instances[id]['formInputs'][0]).on('change', function() {
        // Capture the input context.
        let context = $(this);
        let sliderOverlapping = preventOverlappingSliders(id, context);
        // If the slider is overlapping then exit function.
        if (sliderOverlapping) {
            return false;
        } 

        // If this is a multiple handle slider get the values otherwise just get singular value.
        if (isRange == true) {
            // Update min slider handle position.
            $('div[slider-id=' + id + ']').slider('values' ,0 , getClosestValue($(this), id));
        } else {
            // Get the value.
            let value = context.val();
            // Update min slider handle position.
            $('div[slider-id=' + id + ']').slider('value', value);
        }
    });
    // If this is a range slider then you will have an additional input.
    if (isRange) {
        $('#' + instances[id]['formInputs'][1]).on('change', function() {
            let context = $(this);
            
            let sliderOverlapping = preventOverlappingSliders(id, context);
            // If the slider is overlapping then exit function.
            if (sliderOverlapping) {
                return false;
            } 
    
            // TODO: get input value.
    
            $('div[slider-id=' + id + ']').slider('values' ,1 , getClosestValue($(this), id));
        });
    }
    

    function getClosestValue(context, id) {
        let value = context.val();
        if (instances[id]['values']) {
            // Find the closest value in the values array and return its index.
            value = getClosestIndexValue(instances[id]['values'], value);
        }
        return value;
    }
    return true;
}

function preventOverlappingSliders(id, context) {
    // If setting slider using the slider's handles.
    if (context.values) {
        // If the min > max toggle error..
        if ((context.values[0]) > context.values[1]) {
            // This will need to be expanded if there are multiple types of errors.
            if (!$('div[slider-id=' + id + '] .slider-errors').hasClass('active')) {
                $('div[slider-id=' + id + '] .slider-errors').addClass('active');
            }
            return true;
        } else {
            if ($('div[slider-id=' + id + '] .slider-errors').hasClass('active')) {
                $('div[slider-id=' + id + '] .slider-errors').removeClass('active');
            }
            return false;
        }
    }
    // If setting slider using free text inputs.
    if ((!context.values) && (id)) {
        // Get the min & max values from the text inputs + convert from string to int.
        let min = parseInt($('#' + instances[id]['formInputs'][0]).val());
        let max = parseInt($('#' + instances[id]['formInputs'][1]).val());
        // If min > max toggle error.
        if (min > max) {
            if (!$('div[slider-id=' + id + '] .slider-errors').hasClass('active')) {
                $('div[slider-id=' + id + '] .slider-errors').addClass('active');
            }
            return true;
        } else {

            if ($('div[slider-id=' + id + '] .slider-errors').hasClass('active')) {
                $('div[slider-id=' + id + '] .slider-errors').removeClass('active');
            } 
            return false;
        }  
    }
} 


//TODO: Re-initialise.
function reInit(context) {
    let destroyCurrentSlider = sliderDestroy(context);

    if (!destroyCurrentSlider) {
        AXISDebug.output(3,"Failed to destroy slider.");
        return false;
    }

    let newInstance = initialise(context);

    if (!newInstance) {
        AXISDebug.output(3,"Failed to initialise new slider instance.");
    }
}

// Destroy Slider.
function sliderDestroy(context) {
    // Put the slider into context.
    let id = context.attr('slider-id');
    // Destroy the UI listeners.
    let sliderUiDestroy = $('.slider[slider-id='+ id +']').slider("destroy");
    // Destroy the instance.
    let destroyInstance = instanceDestroy(id);
    // Make sure the the slider is destroyed.
    if (destroyInstance && !sliderUiDestroy.hasClass('ui-slider')) {
        return true;
    }
}

// Instance destroy.
function instanceDestroy(id) {
    if (!id) {
        AXISDebug.output(3,"Cannot destroy instance as no id is defined.");
        return false;
    }
    // Remove instance from instances object.
    delete instances[id];
    // Remove id from slider.
    $('.slider[slider-id=' + id + ']').removeAttr('slider-id');
    // Check if instance is actually destroyed.
    if ($(instances[id]).length == 0) {
        AXISDebug.output(1,"Slider " + id + " Instance destroyed");
        return true;
    } else {
        AXISDebug.output(3,"Failed to destroy slider instance: " + id);
        return false;
    }
}

var AXISSliders = $.AXISSliders = {
    initialise: (context) => {
        return initialise(context);
    },
    initialiseAll: () => {
        return initialiseAll();
    },
    restart: () => {

    },
    destroy: (context) => {
        return sliderDestroy(context);
    }
}

export { AXISSliders }